"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Junction = exports.Pin = exports.Frame = exports.Instance = exports.SheetLayer = exports.Sheet = void 0;
const Common_1 = require("./Common");
const Label_1 = require("./Label");
const Wire_1 = require("./Wire");
const Rectangle_1 = require("./Rectangle");
const Polygon_1 = require("./Polygon");
const Area_1 = require("../../../Area");
const Point_1 = require("./Point");
const Rotation_1 = require("./Rotation");
class Sheet {
    static createSheets(sch) {
        return (0, Common_1.toArray)(sch.drawing.schematic.sheets.sheet).map((sheet) => new Sheet(sheet, sch));
    }
    constructor(sheet, sch) {
        this.metadata = Common_1.Metadata.createFromSchematic(sch);
        this.grid = new Common_1.Grid(sch.drawing.grid);
        this.layers = {};
        const boundary = new Area_1.default();
        sch.drawing.layers.layer.forEach((l) => (this.layers[l._attributes.number] = new SheetLayer(l)));
        let label;
        (0, Common_1.toArray)(sheet.plain.text).forEach((t) => {
            label = Label_1.Label.fromEagleText(t);
            this.layers[label.layer].labels.push(label);
            boundary.extendWithArea(label.getArea());
        });
        (0, Common_1.toArray)(sheet.nets.net).forEach((n) => {
            (0, Common_1.toArray)(n.segment).forEach((s) => {
                let junction;
                (0, Common_1.toArray)(s.junction).forEach((j) => {
                    junction = Junction.createFromEagle(j);
                    this.layers[junction.layer].junctions.push(junction);
                    boundary.extendWithVertices([junction.point.toXYPosition()]);
                });
                let wire;
                (0, Common_1.toArray)(s.wire).forEach((w) => {
                    wire = Wire_1.Wire.createFromEagle(w);
                    this.layers[wire.layer].wires.push(wire);
                    boundary.extendWithVertices(wire.vertices.map((v) => v.toXYPosition()));
                });
            });
        });
        let eaglePart;
        let eagleSymbol;
        let eagleConnects;
        (0, Common_1.toArray)(sheet.instances.instance).forEach((i) => {
            eaglePart = selectPart(i, (0, Common_1.toArray)(sch.drawing.schematic.parts.part));
            eagleSymbol = selectSymbol(i, (0, Common_1.toArray)(sch.drawing.schematic.parts.part), (0, Common_1.toArray)(sch.drawing.schematic.libraries.library));
            eagleConnects = selectConnects(i, (0, Common_1.toArray)(sch.drawing.schematic.parts.part), (0, Common_1.toArray)(sch.drawing.schematic.libraries.library));
            if (!eaglePart || !eagleSymbol) {
                return;
            }
            const instance = new Instance(i, eaglePart);
            if (instance.nameLabel) {
                this.layers[instance.nameLabel.layer].labels.push(instance.nameLabel);
            }
            if (instance.valueLabel) {
                this.layers[instance.valueLabel.layer].labels.push(instance.valueLabel);
            }
            let circle;
            (0, Common_1.toArray)(eagleSymbol.circle).forEach((c) => {
                circle = Common_1.Circle.createFromEagleSchematic(c, instance);
                this.layers[circle.layer].circles.push(circle);
                boundary.extendWithArea(circle.getArea());
            });
            let wire;
            (0, Common_1.toArray)(eagleSymbol.wire).forEach((w) => {
                wire = Wire_1.Wire.createFromEagle(w, instance);
                this.layers[wire.layer].wires.push(wire);
                boundary.extendWithVertices(wire.vertices.map((v) => v.toXYPosition()));
            });
            let pin;
            (0, Common_1.toArray)(eagleSymbol.pin).forEach((p) => {
                pin = new Pin(p, eagleConnects, instance);
                this.layers[pin.layer].pins.push(pin);
                boundary.extendWithVertices([pin.p1.toXYPosition(), pin.p2.toXYPosition()]);
                if (pin.padLabel) {
                    this.layers[pin.padLabel.layer].labels.push(pin.padLabel);
                    boundary.extendWithArea(pin.padLabel.getArea());
                }
                if (pin.nameLabel) {
                    this.layers[pin.nameLabel.layer].labels.push(pin.nameLabel);
                    boundary.extendWithArea(pin.nameLabel.getArea());
                }
            });
            let label;
            (0, Common_1.toArray)(eagleSymbol.text).forEach((t) => {
                label = Label_1.Label.fromEagleText(t, instance);
                if (label.value.startsWith('>') ?? true) {
                    return;
                }
                this.layers[label.layer].labels.push(label);
                boundary.extendWithArea(label.getArea());
            });
            let polygon;
            (0, Common_1.toArray)(eagleSymbol.polygon).forEach((p) => {
                polygon = new Polygon_1.Polygon(p, instance);
                this.layers[polygon.layer].polygons.push(polygon);
                boundary.extendWithVertices(polygon.vertices.map((v) => v.toXYPosition()));
            });
            let rect;
            (0, Common_1.toArray)(eagleSymbol.rectangle).forEach((r) => {
                rect = Rectangle_1.Rectangle.createFromEagle(r, instance);
                this.layers[rect.layer].rectangles.push(rect);
                boundary.extendWithDimensions(rect.point.x, rect.point.y, rect.width, rect.height);
            });
            let frame;
            (0, Common_1.toArray)(eagleSymbol.frame).forEach((f) => {
                frame = new Frame(f);
                this.layers[frame.layer].frames.push(frame);
                boundary.extendWithVertices([frame.p1.toXYPosition(), frame.p2.toXYPosition()]);
            });
        });
        this.metadata.boundary = boundary;
    }
}
exports.Sheet = Sheet;
class SheetLayer {
    constructor(layer) {
        this.labels = [];
        this.wires = [];
        this.rectangles = [];
        this.junctions = [];
        this.circles = [];
        this.pins = [];
        this.polygons = [];
        this.frames = [];
        this.name = layer._attributes.name;
        this.visible = 'yes' === layer._attributes.visible;
        this.color = parseInt(layer._attributes.color);
        this.number = parseInt(layer._attributes.number);
        this.fill = parseInt(layer._attributes.fill);
    }
}
exports.SheetLayer = SheetLayer;
class Instance {
    constructor(i, p) {
        this.point = new Point_1.Point(i._attributes.x, i._attributes.y);
        this.name = i._attributes.part + '::' + i._attributes.gate;
        let rot = i._attributes.rot;
        if (rot?.startsWith('M')) {
            this.mirrored = true;
            rot = rot.substr(1);
        }
        this.rotation = (0, Rotation_1.parseRotationFromDegrees)(rot);
        let { anchor, drawDownXAxis } = Label_1.Label.getDrawDirection(this.rotation);
        if (this.mirrored) {
            anchor = (() => {
                switch (anchor) {
                    case Label_1.Anchor.TopLeft:
                        return Label_1.Anchor.TopRight;
                    case Label_1.Anchor.TopRight:
                        return Label_1.Anchor.TopLeft;
                    case Label_1.Anchor.BottomRight:
                        return Label_1.Anchor.BottomLeft;
                    case Label_1.Anchor.BottomLeft:
                        return Label_1.Anchor.BottomRight;
                    default:
                        return Label_1.Anchor.BottomRight;
                }
            })();
        }
        let a = (0, Common_1.toArray)(i.attribute).find((a) => a._attributes.name === 'NAME');
        if (a && p._attributes.name) {
            this.nameLabel = new Label_1.Label(new Point_1.Point(a._attributes.x, a._attributes.y), 1.778, 95, p._attributes.name, drawDownXAxis, anchor, false);
        }
        a = (0, Common_1.toArray)(i.attribute).find((a) => a._attributes.name === 'VALUE');
        if (a && p._attributes.value) {
            this.valueLabel = new Label_1.Label(new Point_1.Point(a._attributes.x, a._attributes.y), 1.778, 96, p._attributes.value, drawDownXAxis, anchor, false);
        }
    }
}
exports.Instance = Instance;
class Frame {
    constructor(frame) {
        this.p1 = new Point_1.Point(frame._attributes.x1, frame._attributes.y1);
        this.p2 = new Point_1.Point(frame._attributes.x2, frame._attributes.y2);
        this.rows = parseInt(frame._attributes.rows);
        this.columns = parseInt(frame._attributes.columns);
        this.layer = parseInt(frame._attributes.layer);
    }
}
exports.Frame = Frame;
class Pin {
    constructor(pin, connects, parent) {
        const connect = connects.find((c) => c._attributes.pin === pin._attributes.name);
        const dotRadius = 1;
        const labelDistance = 3;
        this.layer = 94;
        const hasDot = !!pin._attributes.function;
        const showNameLabel = !connect || connect._attributes.pad !== connect._attributes.pin;
        const pinLength = (() => {
            switch (pin._attributes.length) {
                case 'point':
                    return 0;
                case 'long':
                    return 7.5;
                case 'middle':
                    return 5;
                case 'short':
                default:
                    return 2.5;
            }
        })();
        this.p1 = new Point_1.Point(pin._attributes.x, pin._attributes.y);
        this.p1 = this.p1.rotate(parent.rotation);
        this.p2 = new Point_1.Point(pinLength, 0);
        let pDot = new Point_1.Point(pinLength - dotRadius, 0);
        let pNameLabel = new Point_1.Point(pinLength + labelDistance, 0);
        if (hasDot) {
            this.p2.x -= dotRadius;
        }
        const rotation = (0, Rotation_1.combineRotations)((0, Rotation_1.parseRotationFromDegrees)(pin._attributes.rot), parent.rotation);
        this.p2 = this.p2.rotate(rotation);
        pDot = pDot.rotate(rotation);
        pNameLabel = pNameLabel.rotate(rotation);
        this.p2.add(this.p1);
        pDot.add(this.p1);
        pNameLabel.add(this.p1);
        if (parent.mirrored) {
            this.p1.x = -this.p1.x;
            this.p2.x = -this.p2.x;
            pDot.x = -pDot.x;
            pNameLabel.x = -pNameLabel.x;
        }
        this.p1.add(parent.point);
        this.p2.add(parent.point);
        pDot.add(parent.point);
        pNameLabel.add(parent.point);
        if (hasDot) {
            this.circle = new Common_1.Circle();
            this.circle.point = pDot;
            this.circle.layer = this.layer;
            this.circle.radius = dotRadius;
        }
        let anchor;
        let drawDownXAxis;
        if ([Rotation_1.Rotation.R0, Rotation_1.Rotation.R180].includes(rotation)) {
            anchor = this.p2.x > this.p1.x ? Label_1.Anchor.BottomRight : Label_1.Anchor.BottomLeft;
            drawDownXAxis = true;
        }
        else {
            anchor = this.p2.y > this.p1.y ? Label_1.Anchor.BottomRight : Label_1.Anchor.BottomLeft;
            drawDownXAxis = false;
        }
        const drawInside = !hasDot || ['long', 'middle'].includes(pin._attributes.length);
        if (drawInside) {
            anchor = anchor === Label_1.Anchor.BottomLeft ? Label_1.Anchor.BottomRight : Label_1.Anchor.BottomLeft;
        }
        if (connect) {
            this.padLabel = new Label_1.Label(this.p1, 1.778, 95, connect._attributes.pad, drawDownXAxis, anchor, false);
        }
        if (showNameLabel) {
            const { anchor, drawDownXAxis } = Label_1.Label.getDrawDirection(rotation);
            this.nameLabel = new Label_1.Label(pNameLabel, 1.778, 95, pin._attributes.name, drawDownXAxis, [Label_1.Anchor.TopRight, Label_1.Anchor.BottomRight].includes(anchor) ? Label_1.Anchor.MiddleRight : Label_1.Anchor.MiddleLeft, false);
        }
    }
}
exports.Pin = Pin;
class Junction {
    static createFromEagle(j) {
        const junction = new Junction();
        junction.point = new Point_1.Point(j._attributes.x, j._attributes.y);
        junction.layer = 91;
        return junction;
    }
}
exports.Junction = Junction;
function selectPart(instance, parts) {
    return parts.find((p) => p._attributes.name === instance._attributes.part);
}
function selectSymbol(instance, parts, libraries) {
    const part = parts.find((p) => p._attributes.name === instance._attributes.part);
    const library = libraries.find((l) => l._attributes.name === part?._attributes.library);
    const deviceset = (0, Common_1.toArray)(library?.devicesets.deviceset).find((d) => d._attributes.name === part?._attributes.deviceset);
    return (0, Common_1.toArray)(library?.symbols.symbol).find((s) => s._attributes.name === (0, Common_1.toArray)(deviceset?.gates.gate)?.[0]._attributes.symbol);
}
function selectConnects(instance, parts, libraries) {
    const part = parts.find((p) => p._attributes.name === instance._attributes.part);
    const library = libraries.find((l) => l._attributes.name === part?._attributes.library);
    const deviceset = (0, Common_1.toArray)(library?.devicesets.deviceset).find((d) => d._attributes.name === part?._attributes.deviceset);
    const device = (0, Common_1.toArray)(deviceset?.devices.device).find((d) => d._attributes.name === part?._attributes.device);
    return (0, Common_1.toArray)(device?.connects?.connect);
}
//# sourceMappingURL=Sheet.js.map